import type { ApiError } from './api/client.js';
import { RATE_LIMIT_RETRY_AFTER_DEFAULT_SEC } from './constants/booking.js';

export function resolveRateLimitRetryAfterSec(error: ApiError): number | null {
  if (error.error?.code !== 'rate_limit_exceeded') return null;
  return (
    error.error?.details?.retryAfterSec ??
    error.error?.retryAfterSec ??
    RATE_LIMIT_RETRY_AFTER_DEFAULT_SEC
  );
}
